export function TermsPage() {
  return (
    <article className="legal-document">
      <h1>Termos de Uso e Condições Gerais</h1>
      <p className="text-muted">
        LONDON SIM GESTÃO DE DOCUMENTOS LTDA (Datasci Editora) — CNPJ 22.390.588/0001-70
        <br />
        Última atualização: Setembro de 2026.
      </p>

      <section>
        <h2>1. Identificação e Objeto</h2>
        <p>
          Estes Termos de Uso regem o acesso, navegação e contratação de serviços oferecidos pela <strong>Datasci Editora</strong>,
          marca comercial e plataforma mantida pela <strong>LONDON SIM GESTÃO DE DOCUMENTOS LTDA</strong>, pessoa jurídica de
          direito privado inscrita no CNPJ sob o nº 22.390.588/0001-70, com sede no Brasil.
        </p>
        <p>
          A plataforma destina-se à comercialização, licenciamento e distribuição eletrônica de obras literárias e técnicas (ebooks)
          em formatos digitais (PDF e EPUB), tanto para consumidores finais individuais quanto para pessoas jurídicas mediante
          contratos corporativos de licenciamento multi-tenant.
        </p>
      </section>

      <section>
        <h2>2. Aceitação dos Termos</h2>
        <p>
          Ao navegar no catálogo, cadastrar-se, realizar pedidos via Pix ou acessar áreas restritas corporativas, você declara ter
          ciência integral e concordar expressamente com estes Termos de Uso, com a nossa Política de Privacidade e com as regras de
          licenciamento aplicáveis ao seu perfil.
        </p>
      </section>

      <section>
        <h2>3. Cadastro e Segurança de Acesso</h2>
        <p>
          O usuário é o único responsável pela veracidade e atualização das informações fornecidas. Para acesso individual,
          o login pode ser realizado mediante e-mail e senha segura ou link mágico temporal de autenticação. Para acesso corporativo,
          o ingresso de colaboradores é condicionado à validação de código de uso único (OTP) enviado ao e-mail institucional do
          domínio contratante.
        </p>
        <p>
          As credenciais de acesso são individuais e intransferíveis. O usuário deve comunicar imediatamente a administração da
          Datasci Editora em caso de extravio, vazamento ou suspeita de uso não autorizado de suas credenciais.
        </p>
      </section>

      <section>
        <h2>4. Compras, Pagamentos e Faturamento Pix</h2>
        <p>
          Os preços das obras são exibidos em Reais (BRL), com pagamento processado de forma instantânea e exclusiva via <strong>Pix</strong>,
          intermediado pelo correspondente bancário <strong>Universal Pagamentos / Celcoin</strong>.
        </p>
        <p>
          A compensação é confirmada mediante conciliação automatizada por webhook idempotente e polling criptografado. Uma vez
          confirmado o recebimento, o direito de acesso digital (<em>entitlement</em>) é imediatamente disponibilizado na seção
          <strong> Minha Biblioteca</strong> da conta do comprador.
        </p>
      </section>

      <section>
        <h2>5. Direitos Autorais e Propriedade Intelectual</h2>
        <p>
          Todo o conteúdo presente na plataforma — incluindo textos, sumários, capas, ilustrações, diagramações, marcas, softwares e
          o conteúdo integral dos ebooks — é protegido pela legislação brasileira de direitos autorais (Lei nº 9.610/1998) e
          propriedade industrial.
        </p>
        <p>
          A aquisição individual ou o acesso corporativo confere exclusivamente uma licença de uso limitada, não exclusiva e
          intransferível. É expressamente proibida a reprodução, engenharia reversa, remoção de marcas d&apos;água digitais,
          redistribuição pública, revenda ou compartilhamento em repositórios abertos, sob as sanções civis e criminais cabíveis.
        </p>
      </section>

      <section>
        <h2>6. Disponibilidade e Limitação de Responsabilidade</h2>
        <p>
          A Datasci Editora envida seus melhores esforços técnicos para assegurar disponibilidade ininterrupta da plataforma. Todavia,
          não se responsabiliza por indisponibilidades temporárias decorrentes de manutenções programadas, falhas em provedores de
          telecomunicações ou eventos de força maior.
        </p>
      </section>

      <section>
        <h2>7. Foro de Eleição</h2>
        <p>
          Estes Termos são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro da comarca da sede da empresa para
          dirimir quaisquer controvérsias oriundas do presente instrumento, com renúncia expressa a qualquer outro.
        </p>
      </section>
    </article>
  );
}
